import { axios } from '../axios';

class LogGamificationService {
  list(body) {
    return axios.post('/gamification/point-log/list', body);
  }
}

export default new LogGamificationService();
